<template>
  <mtd-container>
    <mtd-header height="48px">
      <div class="title">{{ $getText('operation_task_alarm', '数据安全运营平台') }}</div>
      <div class="user-name" style="margin-right: 10px;">
        <mtd-dropdown trigger="hover">
          <mtd-button type="text" style="padding:0;width:22px; min-width: 22px;">
            <img class="user-name-img" :src="login_user.avatar">
          </mtd-button>
          <mtd-dropdown-menu slot="dropdown" class="platform-user-dropdown">
            <mtd-dropdown-menu-item>
              <div class="platform-user-info">
                <img class="platform-user-img" :src="login_user.avatar">
                <span class="platform-user-name">{{login_user.username}}</span>
                <span class="platform-user-name">{{login_user.mis_id}}</span>
              </div>
            </mtd-dropdown-menu-item>
            <mtd-dropdown-menu-item>
              <div style="padding: 4px 12px; color: rgba(0, 0, 0, 0.84);">
                <mtd-button type="text" icon="mtdicon mtdicon-log-out" @click="logout">{{ $getText('operation_btn_logout', '退出') }}</mtd-button>
              </div>
            </mtd-dropdown-menu-item>
          </mtd-dropdown-menu>
        </mtd-dropdown>
      </div>
    </mtd-header>
    <mtd-container>
      <mtd-aside :class="isCollapse? 'isCollapse':''">
        <mtd-menu v-model="activeName" mode="inline" :collapse="isCollapse"
                  @select="menu_click" :default-expanded-names="expanded">
          <div v-for="(item, index) in menu_list" :key="index">
            <mtd-menu-item v-if="item.childrenMenuCount === 0" :name="item.nodeCode">
              {{ item.attributeList.i18n ? $getText(item.attributeList.i18n, item.nodeName) : item.nodeName }}
              <mtd-icon v-if="item.attributeList.icon" :name="item.attributeList.icon" slot="icon" />
            </mtd-menu-item>
            <mtd-submenu v-if="item.childrenMenuCount > 0" :name="item.nodeCode">
              <template slot="title">{{ item.attributeList.i18n ? $getText(item.attributeList.i18n, item.nodeName) : item.nodeName }}</template>
              <mtd-icon v-if="item.attributeList.icon" :name="item.attributeList.icon" slot="icon" />
              <div v-for="(subItem, subIndex) in item.childrenMenuList" :key="subIndex">
                <mtd-menu-item v-if="subItem.childrenMenuCount === 0" :name="subItem.nodeCode">
                  {{ subItem.attributeList.i18n ? $getText(subItem.attributeList.i18n, subItem.nodeName) : subItem.nodeName }}
                  <mtd-icon v-if="subItem.attributeList.icon" :name="subItem.attributeList.icon" slot="icon" />
                </mtd-menu-item>
                <mtd-submenu v-if="subItem.childrenMenuCount > 0" :name="subItem.nodeCode">
                  <template slot="title">{{ subItem.attributeList.i18n ? $getText(subItem.attributeList.i18n, subItem.nodeName) : subItem.nodeName }}</template>
                  <mtd-icon v-if="subItem.attributeList.icon" :name="subItem.attributeList.icon" slot="icon" />
                  <div v-for="(thirdSubItem, thirdSubIndex) in subItem.childrenMenuList" :key="thirdSubIndex">
                    <mtd-menu-item :name="thirdSubItem.nodeCode">
                      {{ thirdSubItem.attributeList.i18n ? $getText(thirdSubItem.attributeList.i18n, subItem.nodeName) : thirdSubItem.nodeName }}
                      <mtd-icon v-if="thirdSubItem.attributeList.icon" :name="thirdSubItem.attributeList.icon" slot="icon" />
                    </mtd-menu-item>
                  </div>
                </mtd-submenu>
              </div>
            </mtd-submenu>
          </div>
        </mtd-menu>
        <div class="collapse-btn-container">
          <mtd-icon-button type="secondary" icon="mtdicon mtdicon-collapse" class="collapse-icon"
                           @click="menus_collapse"/>
        </div>
      </mtd-aside>
      <mtd-main>
        <router-view></router-view>
      </mtd-main>
    </mtd-container>
  </mtd-container>
</template>

<script>
  import sso from '@/utils/sso'

  export default {
    name: "MainLayout",
    data() {
      return {
        isCollapse: true,
        activeName: 'my_alarm',
        expanded: []
      }
    },
    watch: {
      $route: function() {
        this.init_menu();
      }
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      menu_list() {
        return this.$store.getters.get_menu_list;
      }
    },
    mounted: function () {
      this.init_menu();
    },
    methods: {
      init_menu() {
        this.check_govern_page();

        let fullPath = this.$route.fullPath;
        if (!fullPath || fullPath === '/') {
          return;
        }
        fullPath = fullPath.substr(1);
        fullPath = fullPath.split('/');
        if (fullPath.length > 1 && fullPath[0] === 'alarm') {
          this.isCollapse = true;
        } else {
          this.isCollapse = false;
          if (this.$route.name === 'my_govern_risk_detail' || this.$route.name === 'my_govern_unit_detail') {
            this.activeName = 'my_govern_risk';
          } else if (this.$route.name === 'my_govern_order_detail') {
            this.activeName = 'my_govern_order';
          } else {
            this.activeName = this.$route.name;
          }
          this.expanded = this.get_folder_path(this.activeName);
        }
      },
      menu_click(menuItem) {
        let clickItem = this.get_item(menuItem.name);
        if (clickItem) {
          if (clickItem.newOpen) {
            window.open(clickItem.menuURL);
          } else {
            this.$router.push(`${clickItem.menuURL}`);
          }
        }
      },
      get_item(name) {
        let clickItem = null;
        this.menu_list.forEach((item) => {
          if (item.nodeCode === name) {
            clickItem = item;
          }
          item.childrenMenuList.forEach((subItem) => {
            if (subItem.nodeCode === name) {
              clickItem = subItem;
            }
            subItem.childrenMenuList.forEach((thirdSubItem) => {
              if (thirdSubItem.nodeCode === name) {
                clickItem = thirdSubItem;
              }
            });
          });
        });
        return clickItem;
      },
      get_folder_path(name) {
        let folder_path = [];
        this.menu_list.forEach((item) => {
          item.childrenMenuList.forEach((subItem) => {
            if (subItem.nodeCode === name) {
              folder_path.push(item.nodeCode);
            }
            subItem.childrenMenuList.forEach((thirdSubItem) => {
              if (thirdSubItem.nodeCode === name) {
                folder_path.push(item.nodeCode);
                folder_path.push(subItem.nodeCode);
              }
            });
          });
        });
        return folder_path;
      },
      menus_collapse: function () {
        this.isCollapse = !this.isCollapse;
      },
      logout() {
        sso.logout();
      },
      check_govern_page() {
        let fullPath = this.$route.fullPath;
        if (fullPath.indexOf('/govern/') < 0) {
          return;
        }
        let path = this.$route.path;
        let query = ''
        if (fullPath.indexOf('?') > 0) {
          query = fullPath.substring(fullPath.indexOf('?') + 1);
        }
        let isProduction = window.location.host === 'operation.sankuai.com' || window.location.host === 'tjt.sec.st.sankuai.com';
        let url = '';
        if (isProduction) {
          url = 'https://mtdsc.sankuai.com/#' + path;
        } else {
          url = 'https://mtdsc.sec.test.sankuai.com/#' + path;
        }
        if (query) {
          url = url + '?' + query;
        }
        window.location.href = url;
      }
    }
  }
</script>

<style scoped>
  @import "../styles/main-container.css";
  @import "../styles/public.css";

  .user-name .mtd-dropdown {

  }

  .platform-user-dropdown .mtd-dropdown-menu-item {
    padding: 0;
  }

  .platform-user-dropdown .platform-user-info {
    padding: 8px 12px;
    border-bottom: 1px solid #f7f7f7;
    position: relative;
  }

  .platform-user-dropdown .platform-user-info .platform-user-img {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    vertical-align: middle;
    position: absolute;
    top: 17px;
  }

  .platform-user-dropdown .platform-user-info .platform-user-name {
    margin-left: 36px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    display: block;
    line-height: 22px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    cursor: pointer;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item .platform-user-dropdown-link {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) {
    height: 48px;
    line-height: 48px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) i {
    margin-right: 4px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.87);
    vertical-align: middle;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:hover {
    background-color: #f7f7f7;
  }
</style>
